import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Flows/NewDashboard/Sidebar";
import Navbar from "../Flows/NewDashboard/Navbar";
import Overview from "../Flows/NewDashboard/TeamMember/Overview";
export default function TeamMemberLayout() {
  return (
    <div className="relative min-h-screen max-h-[100vh] overflow-y-hidden bg-gray-50 flex flex-col">
      <div className="flex flex-1">
        {/* Sidebar */}
        <Sidebar />
        {/* Main content */}
        <main className="flex-1 overflow-x-auto ">
          <Navbar></Navbar>
          {/* <Outlet></Outlet> */}
          <Overview></Overview>
        </main>
      </div>
    </div>
  );
}
